import React from "react";
import { Reveal } from "./Reveal";
import { INSTITUT_CONTENT } from "@/data/content";

export const About = () => {
  return (
    <section id="institut" data-testid="about" className="bg-white">
      <Reveal className="max-w-2xl mx-auto px-6 pt-14 md:pt-20 pb-8 md:pb-10 text-left">
        <h2 className="font-serif-display text-4xl md:text-5xl text-[#4b2018] mb-6">
          {INSTITUT_CONTENT.welcomeTitle}
        </h2>
        <div
          data-testid="about-text"
          className="space-y-4 text-sm md:text-base leading-relaxed text-[#4b2018] max-w-xl"
        >
          {INSTITUT_CONTENT.welcome.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>

        <div
          aria-hidden="true"
          data-testid="institut-divider"
          className="mt-12 md:mt-14 mx-auto h-px w-14 bg-[#b07a63]/40"
        />
      </Reveal>
    </section>
  );
};
